<template>
  <div class="rule">
    <div>1、活动时间:{{ start }}-{{ end }}; 活动结束前请及请及时使用奖励。</div>
    <div
      >2、完成任务与邀请好友加入betterWE星球即可获取投票券，投票达累计次数即可在活动界面领取对应奖励，奖励以代金券的形式发放，请及时在领奖界面领取奖励并使用。邀请好友暂时只支持邀请大陆用户。</div
    >
    <div
      >3、任务中心:
      完成“带指定话题发布动态”方可解锁其他任务。从活动页面点击“去发布”将自动带上该话题。</div
    >
    <div>4、每日任务可每天完成一次并获取对应的投票券，每天早上7点更新。</div>
    <div
      >5、邀请好友：邀请好友扫码注册betterWE星球账号并下载APP登录，才视为邀请成功。被邀请人添加海报上的助教二维码可免费领取3日真人营养师服务。</div
    >
    <div>6、本活动最终解释权归betterWE星球所有。</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      start: '',
      end: ''
    }
  },
  created() {
    this.start = this.$route.query.start
    this.end = this.$route.query.end
  }
}
</script>
<style lang="scss" scoped>
.rule {
  padding: 20px 20px 89px;
  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  color: rgba(0, 0, 0, 0.8);
  line-height: 28px;
}
</style>
